export default __webpack_public_path__ + "f54102ace81fd0b37395f120742d41b0.svg";